import SearchParamsBase from '../../Elements/SearchParamsBase';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';

export default class UrlShortenerSearchParams extends SearchParamsBase {
  initialize() {
    this.Id = '';
    this.ShortUrlString = '';
    this.Target = '';
    this.Tags = '';

    this.IsActive = true;
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'Id', label: 'Id', className: 'col-4', type: InputTypesEnum.Number },
    {
      fieldName: 'ShortUrlString',
      label: 'Short URL',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Target',
      label: 'Target URL',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'IsActive', label: 'Is Active', className: 'col-4', type: InputTypesEnum.Checkbox },
    { fieldName: 'Tags', label: 'Tags (comma separated)', className: 'col-4', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'UrlShortenerSearchParams';

  //---------------------------
}
